// 财务接口
export function getAccountInfo() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/accountInfo/getAccountInfo'
  })
}
export function getCreditPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/accountInfo/getCreditPageList',
    data
  })
}
export function getTradePageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/accountInfo/getTradePageList',
    data
  })
}
